import createConverter from './lib/create_converter';
import Endpoint from 'models/endpoint';

export default createConverter(Endpoint);
